<template>
  <div class="content-wrap sl-page-wrap" :class="slPage">
    <div class="navi-area">
      <div class="m-navi-top">
        <c-btn01 :btnText="t('message.dashboard')" @click="utils.movePage('/safetyLeadership')"/>
      </div>
      <NaviBox02 @closeMobileMenu="slListOpen"/>
    </div>
    <div class="page2">
      <div class="tab-group">
        <v-tabs
          v-model="tab"
        >
          <v-tab value="tabCont1">{{t('message.safetyLeadership')}}</v-tab>
          <v-tab value="tabCont2">{{t('message.report')}}</v-tab>
          <v-tab value="tabCont3" v-if="(userInfo.roles == 'ADMIN3' && adminInfo.authLeadershipResult > 0)||userInfo.roles == 'ADMIN1'||userInfo.roles == 'ADMIN2'">{{t('message.totalScore')}}</v-tab>
        </v-tabs>
      </div>
      <div class="content-box bg-none tab-cont-wrap">
        <div class="tit-group02 mo-ty01">
          <div class="navi-btn">
            <v-btn @click="slListOpen"/>
          </div>
        </div>
        <v-tabs-window v-model="tab">
          <v-tabs-window-item value="tabCont1">
            <safetyLeadershipRunTabCont1 :is-active="tab === 'tabCont1'"/>
          </v-tabs-window-item>
          <v-tabs-window-item value="tabCont2">
            <safetyLeadershipRunTabCont2 :is-active="tab === 'tabCont2'"/>
          </v-tabs-window-item>
          <v-tabs-window-item value="tabCont3" v-if="(userInfo.roles == 'ADMIN3' && adminInfo.authLeadershipResult > 0)||userInfo.roles == 'ADMIN1'||userInfo.roles == 'ADMIN2'">
            <safetyLeadershipRunTabCont3 :is-active="tab === 'tabCont3'"/>
          </v-tabs-window-item>
        </v-tabs-window>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {onMounted, ref, watch} from 'vue'
import { useRoute } from 'vue-router'
import { useCommonStore } from "@/store/common";
import { storeToRefs } from 'pinia'
import utils from "@/common/Utils";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const route = useRoute()
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const tab = ref('')
const tabIdx = route.params.tab?route.params.tab:''
const viewIdx = route.params.idx?route.params.idx:storeRef.viewIdx.value
const slPage = ref('naviOff')
const userInfo = JSON.parse(localStorage.getItem('user'))
const adminInfo = JSON.parse(localStorage.getItem('admin'))

//hook
onMounted(() => {
  tab.value = 'tabCont'+tabIdx
})

//function
function slListOpen(){
  if(slPage.value == 'naviOff')
    slPage.value = 'naviOn'
  else
    slPage.value = 'naviOff'
}

//같은 주소로 route변경 시 초기화
watch(
  () => route.fullPath,
  () => {
    tab.value = 'tabCont1'
  }
)
</script>


<style lang="scss">
</style>
